import React from 'react';
import Link from '../link';

interface Props {
  title: string;
  documents: MarkdownListDocument[];
}

interface MarkdownListDocument {
  name: string;
  url: string;
}

const MarkdownListDocuments: React.FC<Props> = ({ title, documents }) => (
  <React.Fragment>
    <div className="document-list">
      <h2>{title}</h2>
      <ul>
        {documents.map((document, index) => {
          // Use replace instead of replaceAll due to browser support
          const name = document.name.replace(/-/g, ' ');

          return (
            <li key={index}>
              <Link href={document.url}>
                <a>{name}</a>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .document-list {
        display: block;
        font-family: 'Volvo Novum', sans-serif;
        margin-bottom: 2rem;
      }

      .document-list h2 {
        font-weight: 400;
        margin: 0;
      }

      .document-list ul {
        list-style: none;
        padding: 0;
      }

      .document-list ul li {
        padding-bottom: 1rem;
        margin: 0;
        display: block;
      }

      .document-list ul li:first-letter {
        text-transform: capitalize;
      }

      .document-list a {
        color: #333;
      }

      .document-list a:hover {
        color: #707070;
      }
    `}</style>
  </React.Fragment>
);

export default MarkdownListDocuments;

export type { MarkdownListDocument };
